import { render } from "./MainShopping.vue?vue&type=template&id=1db6f6d0"
import script from "./MainShopping.vue?vue&type=script&lang=js"
export * from "./MainShopping.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__